module.exports = __webpack_public_path__ + "img/LCD_connection.ab169c2a.png";